import { render, staticRenderFns } from "./Medidas.vue?vue&type=template&id=2f8c5a91&scoped=true"
import script from "./Medidas.vue?vue&type=script&lang=js"
export * from "./Medidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8c5a91",
  null
  
)

export default component.exports